export const optionalDateToSWRCache = (
  value: Date | undefined,
): string | undefined => (value ? value.toISOString() : value);

export const optionalDateFromSWRCache = (
  value: string | undefined,
): Date | undefined => (value ? new Date(value) : undefined);
